namespace advisorop.components.servicer {

    export class AppTrackerServicerController {

        constructor() { }

    }

    class AppTrackerServicer implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {};
            this.controller = ["servicerService", AppTrackerServicerController];
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/app-tracker-servicer.html";
        }
    }
    angular.module(Constants.APP).component("appTrackerServicer", new AppTrackerServicer());
}